var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "section",
    {
      staticClass: "cw-block-info",
    },
    [
      _c("header", [_c("translate", [_vm._v("Informationen")])], 1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-block-features-content cw-block-info-content",
        },
        [
          _c(
            "table",
            {
              staticClass: "cw-block-info-table",
            },
            [
              _c("tr", [
                _c("td", [_c("translate", [_vm._v("Blockbeschreibung")])], 1),
                _vm._v(" "),
                _c("td", [_vm._t("info")], 2),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  [_c("translate", [_vm._v("Block wurde erstellt von")])],
                  1
                ),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.owner))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c("translate", [_vm._v("Block wurde erstellt am")]),
                    _vm._v(":"),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("iso-date", {
                      attrs: {
                        date: _vm.block.attributes.mkdate,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c("translate", [_vm._v("Zuletzt bearbeitet von")]),
                    _vm._v(":"),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.editor))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c("translate", [_vm._v("Zuletzt bearbeitet am")]),
                    _vm._v(":"),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("iso-date", {
                      attrs: {
                        date: _vm.block.attributes.chdate,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              on: {
                click: function click($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c("translate", [_vm._v("Schließen")])],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }